import { render } from "./FeatureFlaggingTab.vue?vue&type=template&id=f24ca49a"
import script from "./FeatureFlaggingTab.vue?vue&type=script&lang=js"
export * from "./FeatureFlaggingTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__